import React from 'react';
import { IconStatusConfirmationOnlight } from '@piggybank/core';
export const AcceptPageConfirmation = () => {
  return (
    <span style={{ color: '#00847f' }}>
      <IconStatusConfirmationOnlight inline width="2.5em" />
    </span>
  );
};
